import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const KeepSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default KeepSVG;
